/** @jsxImportSource theme-ui */
import React from 'react';
import { Link as RLink, NavLink as RNavLink } from 'react-router-dom';
import { ButtonProps, Themed } from 'theme-ui';
import { Button, Row, Text } from './core';
import { Link as ThemeLink } from '@theme-ui/components';

export const RouterLink = ({ children, ...props }): JSX.Element => (
  <Themed.a as={RLink} {...props} sx={{ variant: 'a.primary', ...props.sx }}>
    {children}
  </Themed.a>
);

export const RouterNavLink = ({ children, ...props }): JSX.Element => (
  <RNavLink {...props} sx={{ variant: 'a.nav', ...props.sx }}>
    {children}
  </RNavLink>
);

interface ButtonLinkProps extends ButtonProps {
  to?: any;
}

export const ButtonLink = ({
  children,
  sx,
  ...props
}: ButtonLinkProps): JSX.Element => (
  <Button
    as={RLink}
    {...props}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      minWidth: 0,
      sx,
    }}
  >
    {children}
  </Button>
);

export const ExternalLink = ({
  children,
  icon,
  postfix,
  ...props
}: {
  children?: any;
  href: string;
  target?: string;
  rel?: string;
  sx?: any;
  icon?: JSX.Element;
  postfix?: JSX.Element;
}): JSX.Element => (
  <ThemeLink
    variant="a.noUnderline"
    target="_blank"
    rel="noopener noreferrer"
    {...props}
  >
    <Row sx={{ alignItems: 'center' }}>
      {icon}{' '}
      {children && (
        <Text ml={icon ? '.5em' : 0} mr={postfix ? '.5em' : 0}>
          {children}
        </Text>
      )}
      {postfix}
    </Row>
  </ThemeLink>
);
